import theme from "@/theme";
import { buttonPadding } from "@/themeOptions";

export const typeformPopupButtonStyle = {
  "& .typeform-button": {
    width: "100%",
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    outline: 0,
    margin: 0,
    appearance: "none",
    textDecoration: "none",
    fontFamily: "var(--font-host-grotesk)",
    fontWeight: 400,
    textTransform: "none",
    minWidth: "64px",
    border: 0,
    borderRadius: "20px",
    padding: buttonPadding,
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    // transition:
    //   "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    paddingInline: "16px",
    paddingBlock: "16px",
    boxShadow: "none",
    fontSize: "clamp(1.4rem, 1.5vw, 2.2rem)",
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: "transparent",
    },
  },
};
